export default "__VITE_ASSET__tvFUFfpQ__"